"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));
var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));
var _reactInputMask = _interopRequireDefault(require("react-input-mask"));
var _helpers = require("@qwkin/helpers");
var _styledComponents = require("styled-components");
var _FormField = require("./FormField.styles");
var _Icon = require("../Icon");
var _theme = require("../utils/theme");
var _excluded = ["multiple", "items", "icon", "theme", "helperText", "autoComplete", "options", "getOptionLabel", "onBlur", "onChange", "value", "shrink", "rows", "limitTags", "prefix", "focusedColor"],
  _excluded2 = ["theme", "rowsMax", "children", "margin", "variant", "items", "mask", "value", "disabled", "maskChar", "alwaysShowMask", "icon", "helperText", "onChange", "onBlur", "autoComplete", "options", "getOptionLabel", "multiple", "shrink", "rows", "limitTags", "prefix"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var BaseFormField = function BaseFormField(_ref) {
  var multiple = _ref.multiple,
    items = _ref.items,
    icon = _ref.icon,
    theme = _ref.theme,
    helperText = _ref.helperText,
    autoComplete = _ref.autoComplete,
    options = _ref.options,
    getOptionLabel = _ref.getOptionLabel,
    _onBlur = _ref.onBlur,
    _onChange = _ref.onChange,
    value = _ref.value,
    shrink = _ref.shrink,
    rows = _ref.rows,
    limitTags = _ref.limitTags,
    prefix = _ref.prefix,
    focusedColor = _ref.focusedColor,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isFocused = _useState2[0],
    setFocused = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_FormField.FormFieldWrapper, null, autoComplete ? /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], (0, _extends2["default"])({
    style: {
      width: '100%'
    },
    options: options,
    getOptionLabel: getOptionLabel,
    selectOnFocus: true,
    clearOnBlur: true,
    handleHomeEndKeys: true,
    shrink: shrink,
    limitTags: limitTags,
    size: "small",
    multiple: multiple,
    value: value,
    rows: rows,
    onChange: function onChange(v, nv) {
      _onChange(v, nv);
    },
    renderInput: function renderInput(p) {
      return /*#__PURE__*/_react["default"].createElement(_TextField["default"], (0, _extends2["default"])({
        style: {
          width: '100%'
        },
        margin: "dense",
        variant: "outlined",
        maxRows: 20,
        shrink: shrink,
        onFocus: function onFocus() {
          return setFocused(true);
        },
        onBlur: function onBlur() {
          return setFocused(false);
        },
        helperText: helperText,
        onChange: _helpers.identity,
        rows: rows,
        InputProps: {
          startAdornment: prefix !== null && prefix !== void 0 ? prefix : /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], null, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
            style: {
              marginRight: icon ? '8px' : '0',
              marginLeft: icon ? '8px' : '0'
            },
            size: 18,
            color: isFocused ? theme.color.primary["default"] : theme.color.gray,
            icon: icon
          }))
        }
      }, params, p), items && items.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          key: item,
          value: item
        }, item);
      }));
    }
  }, params), items && items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      key: item,
      value: item
    }, item);
  })) : /*#__PURE__*/_react["default"].createElement(_FormField.StyledTextField, (0, _extends2["default"])({
    focusedColor: focusedColor,
    style: {
      width: '100%'
    },
    margin: "dense",
    variant: "outlined",
    maxRows: 20,
    onFocus: function onFocus() {
      return setFocused(true);
    },
    onBlur: function onBlur() {
      setFocused(false);
      if (_onBlur) _onBlur();
    },
    helperText: helperText,
    options: options,
    shrink: shrink,
    getOptionLabel: getOptionLabel,
    onChange: _onChange,
    value: value,
    rows: rows,
    InputProps: {
      startAdornment: prefix !== null && prefix !== void 0 ? prefix : /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], null, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
        style: {
          marginRight: icon ? '8px' : '0',
          marginLeft: icon ? '8px' : '0'
        },
        size: 18,
        color: isFocused ? theme.color.primary["default"] : theme.color.gray,
        icon: icon
      }))
    }
  }, params), items && items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      key: item,
      value: item
    }, item);
  })));
};
var FormField = function FormField(_ref2) {
  var _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? _theme.defaultTheme : _ref2$theme,
    rowsMax = _ref2.rowsMax,
    children = _ref2.children,
    margin = _ref2.margin,
    variant = _ref2.variant,
    items = _ref2.items,
    mask = _ref2.mask,
    value = _ref2.value,
    disabled = _ref2.disabled,
    maskChar = _ref2.maskChar,
    alwaysShowMask = _ref2.alwaysShowMask,
    icon = _ref2.icon,
    helperText = _ref2.helperText,
    _ref2$onChange = _ref2.onChange,
    _onChange2 = _ref2$onChange === void 0 ? _helpers.identity : _ref2$onChange,
    onBlur = _ref2.onBlur,
    autoComplete = _ref2.autoComplete,
    options = _ref2.options,
    getOptionLabel = _ref2.getOptionLabel,
    multiple = _ref2.multiple,
    shrink = _ref2.shrink,
    rows = _ref2.rows,
    _ref2$limitTags = _ref2.limitTags,
    limitTags = _ref2$limitTags === void 0 ? 1 : _ref2$limitTags,
    prefix = _ref2.prefix,
    params = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  if (mask) {
    return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
      theme: theme
    }, /*#__PURE__*/_react["default"].createElement(_reactInputMask["default"], {
      mask: mask,
      maskChar: maskChar,
      alwaysShowMask: alwaysShowMask,
      value: value,
      onChange: function onChange(e) {
        if (e) _onChange2(e.target.value);
      },
      onBlur: onBlur,
      disabled: disabled
    }, function () {
      return /*#__PURE__*/_react["default"].createElement(BaseFormField, (0, _extends2["default"])({
        shrink: shrink,
        items: items,
        icon: icon,
        theme: theme,
        helperText: helperText,
        options: options,
        getOptionLabel: getOptionLabel,
        limitTags: limitTags,
        rows: rows,
        prefix: prefix
      }, params));
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(BaseFormField, (0, _extends2["default"])({
    items: items,
    value: value,
    shrink: shrink,
    onChange: autoComplete ? _onChange2 : function (e) {
      return _onChange2(e.target.value);
    },
    disabled: disabled,
    icon: icon,
    limitTags: limitTags,
    theme: theme,
    helperText: helperText,
    autoComplete: autoComplete,
    multiple: multiple,
    options: options,
    getOptionLabel: getOptionLabel,
    rows: rows,
    prefix: prefix,
    onBlur: onBlur
  }, params)));
};
var _default = exports["default"] = FormField;